import { ApiService } from "./apiService";

export const getNotifications = async (page: number, pageSize: number) => {
  return await ApiService.get(`notifications?page=${page}&page_size=${pageSize}`);
}

export const markNotificationAsRead = async (notificationId: number) => {
  return await ApiService.post(`notifications/${notificationId}/read`, {});
}

export const getUnreadNotificationsCount = async () => {
  return await ApiService.get(`notifications/unread_count`);
}

export const markNotificationsChecked = async () => {
  return await ApiService.post(`notifications/mark_checked`, {});
}
